<template>
	<view class="box">
		<view class="bg">
			<view class="bg-a">可提现余额(元)</view>
			<view class="bg-b">
				<text>1000</text>
				<text>.00</text>
			</view>
			<view class="form">
				<view class="form-a">
					<view class="form-a-label">提现至</view>
					<view class="form-a-val">
						<text>暂无银行信息，点击添加</text>
						<u-icon name="arrow-right" color="#999999" size="16"></u-icon>
					</view>
				</view>
				<view class="form-xian"></view>
				<view class="form-title">提现金额</view>
				<view class="form-input">
					<view class="form-input-dw">￥</view>
					<input type="text" placeholder="0" />
					<view class="form-input-tx">全部提现</view>
				</view>
				<view class="form-error">输入的金额已经超过可提现金额</view>
				<view class="form-btn disable">提交申请</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.bg {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			height: 240rpx;
			background: #004096;
			.bg-a {
				font-weight: 400;
				font-size: 26rpx;
				color: #FFFFFF;
			}
			.bg-b {
				display: flex;
				align-items: baseline;
				margin-top: 14rpx;
				text {
					&:nth-child(1) {
						font-weight: 600;
						font-size: 48rpx;
						color: #FFFFFF;
					}
					&:nth-child(2) {
						font-weight: 600;
						font-size: 26rpx;
						color: #FFFFFF;
					}
				}
			}
			.form {
				width: 100%;
				background: #FFFFFF;
				box-shadow: 0rpx 2rpx 20rpx 0rpx rgba(0,0,0,0.08);
				border-radius: 20rpx;
				margin-top: 30rpx;
				padding: 48rpx 30rpx;
				box-sizing: border-box;
				.form-a {
					width: 100%;
					display: flex;
					align-items: center;
					.form-a-label {
						flex-shrink: 0;
						margin-right: 30rpx;
						font-weight: 400;
						font-size: 30rpx;
						color: #666666;
					}
					.form-a-val {
						flex: 1;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						text {
							font-weight: 400;
							font-size: 28rpx;
							color: #999999;
							margin-right: 20rpx;
						}
					}
				}
				.form-xian {
					width: 100%;
					height: 1rpx;
					margin: 30rpx 0;
					background-color: #E5E5E5;
				}
				.form-title {
					font-weight: 500;
					font-size: 34rpx;
					color: #111111;
				}
				.form-input {
					width: 100%;
					height: 116rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-bottom: 1rpx solid #E5E5E5;
					.form-input-dw {
						flex-shrink: 0;
						font-weight: bold;
						font-size: 30rpx;
					}
					input {
						flex: 1;
						height: 100%;
						font-weight: 500;
						font-size: 40rpx;
						color: #111111;
						margin: 0 30rpx;
					}
					.form-input-tx {
						flex-shrink: 0;
						font-weight: 400;
						font-size: 30rpx;
						color: #004096;
					}
				}
				.form-error {
					font-weight: 400;
					font-size: 26rpx;
					color: #E4001D;
					margin-top: 30rpx;
				}
				.disable {
					color: #CCCCCC !important;
					background: #EFEFEF !important;
				}
				.form-btn {
					width: 100%;
					height: 88rpx;
					line-height: 88rpx;
					text-align: center;
					background: #004096;
					border-radius: 44rpx;
					font-weight: 500;
					font-size: 32rpx;
					color: #FFFFFF;
					margin-top: 48rpx;
				}
			}
		}
	}
</style>